import React from "react";
import { EMBLEM } from "@/lib/api";

export default function Emblem({ size = 96, glow = true, className = "" }) {
  return (
    <img
      src={EMBLEM}
      alt="RSP Riverside emblem"
      width={size}
      height={size}
      className={`${glow ? "emblem-glow" : ""} rounded-full object-cover select-none ${className}`}
      draggable={false}
      data-testid="rsp-emblem"
    />
  );
}
